/* requires:
jquery-3.3.1.js
swiper.js
ofi.js
*/

document.addEventListener("DOMContentLoaded", ready);


function ready() {
    window.onscroll = () => {
        window.requestAnimationFrame(makeHeader);
    };

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.onresize = () => {
    window.requestAnimationFrame(makeHeader);
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

var navbar = document.getElementById("navbar"),
    main = document.getElementById("main"),
    header_logo_use = document.getElementById("header-logo-use"),
    changeHead = document.getElementsByClassName('change-head')[0];

function isMobileDevice() {
    return (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) <= 768);
}

var sticky = changeHead ? changeHead.offsetHeight : navbar.offsetHeight;

$(window).resize(function(){
    sticky = changeHead ? changeHead.offsetHeight : navbar.offsetHeight;
});

function makeHeader() {
    if (window.pageYOffset >= sticky || document.documentElement.scrollTop >= sticky) {
        navbar.classList.add("header--white");
        if (header_logo_use) {
            header_logo_use.setAttribute("xlink:href", "#Group_2_b");
        }
    } else {
        navbar.classList.remove("header--white");
        if (header_logo_use) {
            header_logo_use.setAttribute("xlink:href", "#Group_2");
        }
    }
}

var isVisible = function (el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
};

var $ = jQuery.noConflict();

$("document").ready(function () {

    // if ($("#contact-form").length > 0) {
    //     $("a[href*='contact-form']").hide();
    // }
    //
    // $("a[data-href*='#contact-form']").click(function (e) {
    //     e.preventDefault();
    //     window.location.href = document.location.origin + $(this).attr("data-href");
    // });

    if($('.common-page-content').length > 0) {
        $('#navbar').addClass('main');
    } else if($('.blog-head').length > 0) {
        $('#navbar').addClass('main');
    }

    if (window.location.href.indexOf("##contact-form") > 0) {
        setTimeout(function () {
            $('html, body').stop().animate({
                scrollTop: $(".contact-form").offset().top - $("#navbar").outerHeight()
            }, 1000, function () {
            });
        }, 100);
    }

    // changed start!

    var win = $(window);
    var body = $('body');

    var winHeight = win.height();
    var animElements = $('.animate-element');

    var swanHero = $('.swan-water-label');
    var letTalkButton = $('.let-talks-button');
    var appItems = $('.applications-table__item');

    if(appItems.length) {
        let double = 1;

        for(var i = 0; i < appItems.length; i++) {
            if(i !== 0 && double % 2 !== 0) {
                appItems.eq(i).css('transition-delay', ((i / 20) + 0.1) + 's');
                appItems.eq(i + 1).css('transition-delay', (((i + 1) / 20) + 0.1) + 's');
            }

            double++;
        }
    }

    body.on('click', 'a[data-href*="#contact-form"]', function(e) {
        e.preventDefault();

        if($("#contact-form").length > 0) {
            $('html, body').stop().animate({
                scrollTop: $(".contact-form").offset().top - $("#navbar").outerHeight()
            }, 1000);
        } else {
            window.location.href = document.location.origin + $(this).attr("data-href");
        }
    });

    function brainDraw() {
        var brainContainer = $('.brain-icon-container');

        if(brainContainer.length && brainContainer.hasClass('brain-hidden')) {
            brainContainer.removeClass('brain-hidden');
            var vivusAnim = new Vivus('brain-icon-svg', {type: 'delayed', duration: 120});

            vivusAnim.play();
        }
    }

    function showElement(el) {
        if(el.hasClass('animate-lightup') && !el.hasClass('visible')) {
            (function(){
                var items = el.find('.paradigm-index-item');

                if(items.length > 0) {
                    for(let i = 0; i < items.length; i++) {
                        setTimeout(function(){
                            items.eq(i).addClass('check-lightup');

                            setTimeout(function(){
                                items.eq(i).removeClass('check-lightup');
                            }, 500 + (i * 10));
                        }, (i * 200));
                    }
                }

                return false;
            })();
        }

        el.addClass('visible');

        setTimeout(() => {
            el.addClass('finished');
        }, 1500);
    }

    function animationEvent(elements, yPosition, delta){
        var winTopPos = yPosition + winHeight - delta;

        elements.each(function(i, elem) {
            var element = $(elem);

            var elemHeight = element.height();
            var elemTop = element.offset().top;
            var elemTopPos = (elemTop + elemHeight);

            if((elemTopPos >= yPosition) && (elemTop <= winTopPos)) {
                brainDraw();
                showElement(element);
            }
        });
    }

    showElement(body);
    showElement(swanHero);
    showElement(letTalkButton);
    animationEvent(animElements, 0, winHeight / 20);

    win.scroll(function(){
        var position = $(document).scrollTop();

        animationEvent(animElements, position, winHeight / 20);
    });

    win.resize(function(){
        winHeight = win.height();
    });

    new Swiper('#use-slider', {
        loop: true,
        spaceBetween: 30,
        navigation: {
            nextEl: '.use-button-next',
            prevEl: '.use-button-prev',
        }
    });

    const blogTexts = $('.blog-head-text');

    const swiperBlog = new Swiper('.blog-head-slider', {
        spaceBetween: 0,
        autoplay: {
            delay: 5000
        },
        pagination: {
            el: '.blog-head-pagination',
            type: 'bullets',
            clickable: true
        },
        on: {
            init: function (){
                blogTexts.eq(0).addClass('active');
            },
            slideChange: function(){
                blogTexts.removeClass('active');
                blogTexts.eq(swiperBlog.activeIndex).addClass('active');
            }
        }
    });

    function whyTabs() {
        var buttonsName = '.why-tab';
        var contents = $('.why-section-ch');
        var contentWrapper = $('.why-section-change');

        if(contents && $(buttonsName)) {
            body.on('click', buttonsName, function(){
                var self = $(this);
                var selfIndex = self.index();
                var heightContent = contentWrapper.height();

                $(buttonsName).removeClass('active');
                self.addClass('active');

                contentWrapper.height(heightContent);
                contentWrapper.addClass('hidden');

                setTimeout(function(){
                    contents.removeClass('active');
                    contents.eq(selfIndex).addClass('active');
                }, 330);

                setTimeout(function(){
                    contentWrapper.removeClass('hidden');
                    contentWrapper.css('height', 'auto');
                }, 660);
            });
        }
    }

    whyTabs();

    function intelligenceTabs() {
        var tabNames = '.intelligence-tab';

        var container = $('.intelligence-inner');
        var imgContents = $('.intelligence-inform-tab');
        var listConenets = $('.intelligence-list-item');

        body.on('click', tabNames, function(){
            var ind = $(this).index();

            container.addClass('disable');

            $(tabNames).removeClass('active');
            imgContents.removeClass('active');
            listConenets.removeClass('active');

            $(this).addClass('active');

            setTimeout(function(){
                container.removeClass('disable');
                imgContents.eq(ind).addClass('active');
                listConenets.eq(ind).addClass('active');
            }, 500);
        });
    }

    intelligenceTabs();

    function infoInt(timeout){
        setTimeout(function(){
            $('html, body').stop().animate({
                scrollTop: $(".intelligence-info").offset().top - $("#navbar").outerHeight() * 2.5
            }, 1000, function () {
            });
        }, timeout);
    }

    function storiesInt(timeout){
        setTimeout(function(){
            $('html, body').stop().animate({
                scrollTop: $(".intelligence-stories").offset().top - $("#navbar").outerHeight()
            }, 1000, function () {
            });
        }, timeout);
    }

    function successInt(timeout){
        setTimeout(function(){
            $('html, body').stop().animate({
                scrollTop: $(".intelligence-stories-top").offset().top - $("#navbar").outerHeight() * 2
            }, 1000, function () {
            });
        }, timeout);
    }

    if (window.location.href.indexOf("#industires") > 0) {
        infoInt(100);
    }

    if (window.location.href.indexOf("#stories") > 0) {
        storiesInt(100);
    }

    if (window.location.href.indexOf("#success-stories") > 0) {
        successInt(100);
    }

    body.on('click', 'a', function() {
        if($(this).attr('href').indexOf('#industires') > 0) {
            infoInt(0);
        }

        if($(this).attr('href').indexOf('#stories') > 0) {
            storiesInt(0);
        }

        if($(this).attr('href').indexOf('#success-stories') > 0) {
            storiesInt(0);
        }
    });

    // changed end!


    $(function () {
        //objectFitImages('img.img-fit');
    });

    var contact_form_container = document.getElementById("contact-form");

    if (isVisible(contact_form_container)) {
        $("[data-target='#contact-form']").fadeOut();
    } else {
        $("[data-target='#contact-form']").fadeIn();
    }

    $(window).on('scroll', function () {
        if (isVisible(contact_form_container)) {
            $("[data-target='#contact-form']").fadeOut();
        } else {
            $("[data-target='#contact-form']").fadeIn();
        }
    });

    var elements_feature_swiper = new Swiper('.element-features__swiper', {
        spaceBetween: 5,
        navigation: {
            nextEl: '.element-features__next',
            prevEl: '.element-features__prev',
        },
        loop: true
    });

    var latest_news__swiper = new Swiper('.latest-news__swiper', {
        spaceBetween: 0,
        slidesPerView: 3,
        navigation: {
            nextEl: '.latest-news__next',
            prevEl: '.latest-news__prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
                loop: true
            }
        },

    });

    var ai_ios_we_differ__swiper = new Swiper('.ai-ios-we-differ__swiper', {
        spaceBetween: 2,
        slidesPerView: 3,
        navigation: {
            nextEl: '.ai-ios-we-differ__next',
            prevEl: '.ai-ios-we-differ__prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            450: {
                slidesPerView: 1
            }
        },
        loop: true
    });

    $('[data-target]').click(function (e) {
        e.preventDefault();
        var elem_hash = $(this).attr("data-target"),
            target = $(elem_hash);
        $('html, body').animate({
            scrollTop: target.offset().top - $("#navbar").height() - 200
        }, 500, "linear");
    });

    /*$("body").css('padding-top', $("header").height());
    $(window).resize(function () {
        $("body").css('padding-top', $("header").height());
    });*/

    if ($("body").hasClass("home") && !isMobileDevice()) {
        $(".effective-way").height($(".effective-way__notebook").height());
    }

    $(".contact-form__input").focus(function () {
        $(this).parent().addClass("contact-form__row--focus");
    });
    $(".contact-form__input").blur(function () {
        if ($(this).val()) return;
        $(this).parent().removeClass("contact-form__row--focus");
    });

    $(".dropdown__toggle, .dropdown__content").click(function () {
        var target = $(this).parent(".dropdown");
        if (target.hasClass("show")) {
            target.removeClass("show");
        } else {
            $(".dropdown").each(function () {
                if ($(this).hasClass("show")) {
                    $(this).removeClass("show");
                }
            });
            target.addClass("show");
        }
    });

    $(window).click(function (e) {
        if ($(".dropdown").is(e.target) || !($(".dropdown").has(e.target).length === 0)) {
            // return false;
        } else {
            $(".dropdown").each(function () {
                if ($(this).hasClass("show")) {
                    $(this).removeClass("show");
                }
            });
        }
    });

    $("#home-video").each(function () {
        var video = this;
        $(video).on("ended", function () {
            $(video).addClass("fading");
            setTimeout(function () {
                video.play();
                $(video).removeClass("fading");
            }, 1500);
        });
    });

    $(".slidedown__toggle").click(function () {
        $(this).parents(".slidedown").toggleClass("active");
    });

    $(".mobile-menu__close").click(function () {
        var el = $(this);
        $(el).addClass("scaling");
        setTimeout(function () {
            $(".mobile-menu").removeClass("show");
            setTimeout(function () {
                $(el).removeClass("scaling");
            }, 400);
        }, 350);
    });
    $(".header__menu-btn").click(function () {
        var el = $(this);
        $(el).addClass("scaling");
        setTimeout(function () {
            $(".mobile-menu").addClass("show");
            setTimeout(function () {
                $(el).removeClass("scaling");
            }, 400);
        }, 400);
    });

    $("body").each(function () {
        if ($(this).hasClass("home")) return false;
        $(this).css('padding-top', $("#navbar").outerHeight());
    });

    $(".panel-toggle").click(function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
        } else {
            $(".panel-toggle.active").each(function () {
                $(this).removeClass("active");
            });
            $(this).addClass("active");
        }
    });

    $(".popup-toggle").click(function (e) {
        var toggle_attr = $(this).attr("data-popup"),
            target = $(".popup[data-index=" + toggle_attr + "]");

        $(".popup-toggle").each(function () {
            $(this).addClass("faded");
        });
        $(this).removeClass("faded");
        $(".popup").each(function () {
            $(this).removeClass("active");
        });
        $(target).addClass("active");
        if (isMobileDevice()) {

            $("body").addClass("noscroll");
        }

    });

    $(".popup__close").click(function () {
        $(this).parents(".popup").removeClass("active");
        $(".popup-toggle").each(function () {
            $(this).removeClass("faded");
        });
        if (isMobileDevice()) {

            $("body").removeClass("noscroll");
        }
    });

    equalHeight(".big-card__content");
    // equalHeight(".news-card__content");
    equalHeight(".how-we-help__text");
    equalHeight(".simple-card");
    equalHeight(".industries-page__card");
    equalHeight(".event-page-content__boxes");

    $(window).on('resize', function () {
        equalHeight(".big-card__content");
        // equalHeight(".news-card__content");
        equalHeight(".how-we-help__text");
        equalHeight(".simple-card");
        equalHeight(".industries-page__card");
        equalHeight(".event-page-content__boxes");
        if ($("main").hasClass("blog-page")) {
            // $(".blog-hero__blue").outerHeight($(".blog-hero__swiper").height());
        }
    });
});

var isVisible = function (el) {
    if (el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    } else {
        return false;
    }
};

function equalHeight(elem) {
    if (parseInt($(elem).length) === 0) return;
    var max_height = 0;
    $(elem).each(function () {
        max_height = Math.ceil((max_height > $(this).height()) ? max_height : $(this).height());
    });
    $(elem).each(function () {
        if ($(this).hasClass("event-page-content__boxes")) {
            $(this).outerHeight(max_height);
        } else {
            $(this).height(max_height);
        }
    });
}